<template>
  <div class="product-bonus" v-if="bonusesCount">
    <div>
      <f-sprite-icon :icon-link="$options.icons.IconCard.id" />
    </div>
    {{ bonusesCount }} бонусов на клубную карту
  </div>
</template>

<script>
/* Icons */
import IconCard from '@icons/club-card.multi.svg';

export default {
  name: 'product-bonus',

  icons: {
    IconCard,
  },

  props: {
    bonus: {
      type: Array,
      default: () => [],
    }
  },

  computed: {
    bonusesCount() {
      return this.bonus[0]?.amount || 0;
    }
  }
}
</script>

<style lang="scss">
.product-bonus {
  display: flex;
  align-items: center;
  font-size: 12px;
  line-height: 16px;

  & > div {
    width: 32px;
    height: 24px;
    margin-right: 12px;
  }
}

@include breakpoint("desktop") {
  .product-bonus {
    font-size: 14px;
  }
}
</style>